import { createContext } from "react";
import { CarContextDetails } from "./types";

export const CarCompetitionData = createContext<CarContextDetails>({
  competitionId: 0,
  prizeId: 0,
  prizeTitle: "",
  prizeSubtitle: "",
  cashAlternativeText: "",
  hideCashAlternative: false,
  carValue: "",
  carValueNumber: 0,
  description: "",
  detailsHtml: "",
  specs: [],
  media: [],
  heroImage: "",
  specsImage: "",
  galleryImages: [],
  isPrizeAvailable: false,
  shouldShowSubscriptionDrawer: false,
  competitionState: "over14Weeks",
  currencySymbol: "£",
  ticketPriceLabel: "",
  countdownText: "",
  competitionEndDate: "",
  isVideo: false,
  secondarySectionHtml: "",
  secondarySectionCtaText: "",
  secondarySectionPopupHtml: "",
  setContextData: () => {},
});
